<div class="buscar-tipo-movimiento">

  <mat-form-field class="campo">
    <mat-label>{{ etiqueta }}</mat-label>

    <!-- Con el tipo ya elegido, el signo queda a la vista sin tener que abrir la lista -->
    <span matPrefix class="badge-signo prefijo" *ngIf="seleccionado"
      [class.resta]="seleccionado.resta" [class.suma]="!seleccionado.resta"
      [matTooltip]="seleccionado.resta ? 'Resta: descuenta del total' : 'Suma: se agrega al total'">
      <mat-icon>{{ seleccionado.resta ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
      {{ seleccionado.resta ? '-' : '+' }}
    </span>

    <input type="text" matInput [formControl]="control" [matAutocomplete]="auto"
      placeholder="Elegí de la lista o escribí para buscar"
      (focus)="abrirListado()" (click)="abrirListado()">

    <mat-icon matSuffix class="icono-desplegar" *ngIf="!control.value">arrow_drop_down</mat-icon>

    <button mat-icon-button matSuffix type="button" *ngIf="control.value && !deshabilitado"
      (click)="limpiar(); $event.stopPropagation()" matTooltip="Limpiar">
      <mat-icon>close</mat-icon>
    </button>

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="mostrarDescripcion"
      (optionSelected)="onSeleccion($event.option.value)">
      <mat-option *ngFor="let tipo of opcionesFiltradas | async; trackBy: trackByItems" [value]="tipo"
        [matTooltip]="tipo.descripcion">
        <span class="opcion">
          <span class="badge-signo" [class.resta]="tipo.resta" [class.suma]="!tipo.resta"
            [matTooltip]="tipo.resta ? 'Resta: descuenta del total' : 'Suma: se agrega al total'">
            <mat-icon>{{ tipo.resta ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
            {{ tipo.resta ? '-' : '+' }}
          </span>

          <span class="descripcion">{{ tipo.descripcion }}</span>

          <mat-icon class="icono-comision" [class.con-comision]="tipo.tieneComision"
            [matTooltip]="tipo.tieneComision ? 'Genera comisión para la inmobiliaria' : 'No genera comisión'">
            {{ tipo.tieneComision ? 'percent' : 'remove' }}
          </mat-icon>
        </span>
      </mat-option>
    </mat-autocomplete>

    <mat-error *ngIf="control.errors?.required">
      Este campo es <strong>requerido</strong>.
    </mat-error>
  </mat-form-field>

  <button mat-icon-button type="button" class="menu-acciones" *ngIf="permiteAlta && !deshabilitado"
    [matMenuTriggerFor]="menuTipoMovimiento" matTooltip="Acciones">
    <mat-icon>more_vert</mat-icon>
  </button>

  <mat-menu #menuTipoMovimiento="matMenu">
    <button mat-menu-item type="button" (click)="nuevoTipoMovimiento()">
      <mat-icon>add</mat-icon>
      <span>Nuevo tipo de movimiento</span>
    </button>
    <button mat-menu-item type="button" (click)="editarTipoMovimiento()" [disabled]="!seleccionado">
      <mat-icon>edit</mat-icon>
      <span>Editar seleccionado</span>
    </button>
  </mat-menu>

</div>
